export default "__VITE_ASSET__CzjMk6UM__"